/**
 * 차트 시리즈 색 — «고정 순서»다. 돌려쓰지 말 것.
 *
 * 6개 검사(명도대·채도·색각이상 분리·정상시야 분리·표면대비)를 통과한 순서다.
 * 순서를 바꾸거나 값을 갈아끼우면 인접쌍 분리가 깨진다 —
 * 바꿔야 하면 검사를 다시 돌리고 나서 바꿔라.
 *
 * 6번째 시리즈가 필요하면 새 색을 만들지 말고 «기타»로 묶거나 차트를 나눈다.
 */
export const SERIES = [
  '#c22f46', // 1 코랄 (브랜드)
  '#12579e', // 2 블루
  '#8a4b0a', // 3 오렌지
  '#6b21a8', // 4 퍼플
  '#186b3c', // 5 그린
] as const;

/** 축·격자 — 데이터보다 뒤로 물러나야 한다 */
export const CHART_GRID = '#e5e5ea';
export const CHART_AXIS = '#5c5c6b';

/** 의미가 고정된 색. 시리즈 색으로 돌려쓰지 마라. */
export const SEMANTIC = {
  matched: '#186b3c',
  failed: '#a81e32',
  pending: '#8a4b0a',
  inactive: '#5c5c6b',
} as const;
